/**
 * Fit Videos regardless of aspect ratio
 */

import $ from 'jquery';

const fitVids = {
  // initWithJSCheck: () => {
  //   let timer;

  //   if ( $('.site-main').hasClass('no-js') ) {
  //     timer = setTimeout(() => {
  //       fitVids.initWithJSCheck();
  //     }, 100);
  //   } else {
  //     clearTimeout(timer);
  //     fitVids.initFitVids();
  //   }
  // },

  initFitVids: () => {
    // Get all videos on screen
    const allVids = $('.video');

    allVids.each(function () {
      // Get all video containers
      const block = $(this);
      const containers = $(this).find('.container');
      const videoContainer = $(this).find('.video-container');
      let container;
      let outerContainer;

      // Get iFrames
      const iframes = $(this).find('iframe');

      // Calculate aspect ratio for videos
      iframes.each(function () {
        $(this)
          .data('aspectRatio', this.height / this.width)
          .removeAttr('height')
          .removeAttr('width');
      });

      containers.each(function () {
        if ($(this).find(':first-child').hasClass('video-container')) {
          container = $(this);
          outerContainer = $(this);
        }
      });

      // On window resize
      $(window)
        .on('resize', function () {
          const newWidth = videoContainer.width();

          // Resize videos
          iframes.each(function () {
            const el = $(this);
            // Set iframe size
            el.width(newWidth).height(newWidth * el.data('aspectRatio'));

            // Set container height
            videoContainer.height(newWidth * el.data('aspectRatio'));

            // Set video max-height
            if (block.hasClass('regular')) {
              if (newWidth > 768) {
                container.height(newWidth * 0.3192);
              } else {
                container.height(newWidth * 0.4345);
              }
            } else if (block.hasClass('extra-tall')) {
              if (newWidth > 768) {
                container.height(newWidth * 0.4275);
                el.css('transform', 'translateX(0)');
              } else if (newWidth <= 768 && newWidth > 428) {
                container.height(newWidth * 0.8359);
                el.width(newWidth * 1.5).height(newWidth * el.data('aspectRatio') * 1.5);
                videoContainer.height(newWidth * el.data('aspectRatio') * 1.5);
                el.css('transform', 'translate(0 0)');
              } else {
                container.height(newWidth * 0.8364);
                el.width(newWidth * 1.5).height(newWidth * el.data('aspectRatio') * 1.5);
                videoContainer.height(newWidth * el.data('aspectRatio') * 1.5);
                el.css('transform', 'translate(-30% 0)');
              }
            }

            if (block.hasClass('banner-full-width-video')) {
              outerContainer.height(newWidth * 0.3033);
            }
          });
        })
        .trigger('resize');
    });
  },
};

export default fitVids;
